import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { EMRService } from 'app/EMR/EMR.service';
import { EyecheckComponent } from 'app/EMR/eyecheck/eyecheck.component';
import { MatDialog } from '@angular/material/dialog';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { HelplistService } from 'app/helplist.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-ud_and_d_refration',
  templateUrl: './ud_and_d_refration.component.html',
  styleUrls: ['./ud_and_d_refration.component.scss']
})
export class Ud_and_d_refrationComponent implements OnInit {
  destroyud$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('udrs1') udrs1: ElementRef;
  @ViewChild('udrc1') udrc1: ElementRef;
  @ViewChild('udra1') udra1: ElementRef;
  @ViewChild('udrp1') udrp1: ElementRef;
  @ViewChild('udrv1') udrv1: ElementRef;
  @ViewChild('udnvr1') udnvr1: ElementRef;
  @ViewChild('udrs2') udrs2: ElementRef;
  @ViewChild('udrc2') udrc2: ElementRef;
  @ViewChild('udra2') udra2: ElementRef;
  @ViewChild('udrp2') udrp2: ElementRef;
  @ViewChild('udrv2') udrv2: ElementRef;
  @ViewChild('udrs3') udrs3: ElementRef;
  @ViewChild('udrc3') udrc3: ElementRef;
  @ViewChild('udra3') udra3: ElementRef;
  @ViewChild('udrp3') udrp3: ElementRef;
  @ViewChild('udrv3') udrv3: ElementRef;
  @ViewChild('udls1') udls1: ElementRef;
  @ViewChild('udlc1') udlc1: ElementRef;
  @ViewChild('udla1') udla1: ElementRef;
  @ViewChild('udlp1') udlp1: ElementRef;
  @ViewChild('udlv1') udlv1: ElementRef;
  @ViewChild('udnvl1') udnvl1: ElementRef;
  @ViewChild('udls2') udls2: ElementRef;
  @ViewChild('udlc2') udlc2: ElementRef;
  @ViewChild('udla2') udla2: ElementRef;
  @ViewChild('udlp2') udlp2: ElementRef;
  @ViewChild('udlv2') udlv2: ElementRef;
  @ViewChild('udls3') udls3: ElementRef;
  @ViewChild('udlc3') udlc3: ElementRef;
  @ViewChild('udla3') udla3: ElementRef;
  @ViewChild('udlp3') udlp3: ElementRef;
  @ViewChild('udlv3') udlv3: ElementRef;
  @ViewChild('drs1') drs1: ElementRef;
  @ViewChild('drc1') drc1: ElementRef;
  @ViewChild('dra1') dra1: ElementRef;
  @ViewChild('drv1') drv1: ElementRef;
  @ViewChild('dls1') dls1: ElementRef;
  @ViewChild('dlc1') dlc1: ElementRef;
  @ViewChild('dla1') dla1: ElementRef;
  @ViewChild('dlv1') dlv1: ElementRef;
  
//   dilatedStringArray=['udrs1','udrc1','udra1','udrp1','udnvr1','udrs2','udrc2','udra2','udrp2','udrv2',
//   'udrs3','udrc3','udra3','udrp3','udrv3','udls1','udlc1','udla1','udlp1','udlv1','udnvl1','udls2','udlc2',
// 'udla2','udlp2','udlv2','udls3','udlc3','udla3','udlp3','udlv3','drs1','drc1','dra1','drv1','dls1','dlc1','dla1','dlv1'];
private selectValue: any;
 // private selectedValue: any;
  private dialated: boolean = false;
  private undialated: boolean = true;
  // selectedValue:any ='Add';
  private plusValues: any = [];
  private minusValues: any = [];
  private axisvalue: any = [];
  private prismvalue: any = [];
  private vaValue: any = [];
  private inputtype: string = null;
  private allowtablevalue: number = 0;
  constructor(private emrservice: EMRService, private helplistservice: HelplistService, private dashboardService: DashboardService,
    private dialog: MatDialog,@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
    this.emrservice.enabledisableUd = true;
    // this.selectValue='Add';
    // this.emrservice.getAddNearValue().pipe(takeUntil(this.destroyud$)).subscribe(info => {
    //   this.selectedValue = info;

    // });
    let countries;
    countries = this.helplistservice.eyevisiontypes_SPH.slice();
    this.plusValues = countries.filter((country) => country.popupDescription.startsWith("+"));
    this.minusValues = countries.filter((country) => country.popupDescription.startsWith("-"));
    this.axisvalue = this.helplistservice.eyevisiontypes_AXS.slice();
    this.prismvalue = this.helplistservice.eyevisiontypes_CYL.slice();
    this.vaValue = this.helplistservice.eyevisiontypes_VA.slice();
    
  }
  checknearvalue(value){
    if(value){
     return value;
    }else{
     this.emrservice.opto.nearType='Add';
     return 'Add';
    }
   }
  ngOnDestroy():void{
    this.destroyud$.next(true);
    this.destroyud$.unsubscribe();
    this.plusValues=null;
    this.minusValues=null;
    this.axisvalue=null;
    this.prismvalue=null;
    this.vaValue=null;
  }
 
  getsphvalue(category: string, valuebox: string) {
    this.emrservice.ar_value_box = valuebox;
    this.emrservice.eyechkcategory = category;
    const dialogRef = this.dialog.open(EyecheckComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '50vw',
      // height: '80%',
      width: '100%',
      data: {
        //category: category,
        //userid: this.authService.Loggeduser.userid
      }

    });

      dialogRef.afterClosed().pipe(takeUntil(this.destroyud$)).subscribe(result => {
      this.emrservice.enabledisableUd = false;
      if( valuebox=='r2_A_c1_udr'){
        this.emrservice.opto.nearType='Near';
      }
      if( valuebox=='r2_A_c1_udr' && this.emrservice.opto.nearType=='Near'){
        this.emrservice.opto.udrc2=this.emrservice.opto.udrc1;
        this.emrservice.opto.udra2=this.emrservice.opto.udra1;
        this.emrservice.opto.udlc2=this.emrservice.opto.udlc1;
        this.emrservice.opto.udla2=this.emrservice.opto.udla1;
      }
     
      if( valuebox=='r2c1_A_udr' && this.emrservice.opto.nearType=='Near'){
        this.emrservice.opto.udlc2=this.emrservice.opto.udlc1;
      }
      if( valuebox=='r2c1_A_udr' && this.emrservice.opto.nearType=='Near'){
        this.emrservice.opto.udla2=this.emrservice.opto.udla1;
      }
      //  console.log('The dialog was closed');
      //pid = result;
      // this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory.slice());

    });
  }
  checkDilated($event) {
    this.emrservice.enabledisableUd = false;
  }
  dialatedBtn() {
    this.dialated = true;
    this.undialated = false;
  }
  undialatedBtn() {
    this.dialated = false
    this.undialated = true;
  }
  refReasonPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

     dialogRef.afterClosed().pipe(takeUntil(this.destroyud$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisableUd = false;
        if (type == 1) {
          this.emrservice.opto.dlremarks = result;
        } else if (type == 2) {
          this.emrservice.opto.udremarks = result;
        }

      }
    });
  }
  refhelplistPOpup(type, value) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }

    });

     dialogRef.afterClosed().pipe(takeUntil(this.destroyud$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisableUd = false;
        this.selectValue = result;
        this.set_opto_udandd_values(value);
      }
    });
  }
  set_opto_udandd_values(row) {

    switch (row) {

      // row 1
      case "r1c1_udr": {
        this.emrservice.opto.udrs1 = this.selectValue;
        break;
      }
      case "r1c2_udr": {
        this.emrservice.opto.udrc1 = this.selectValue;
        break;
      }
      case "r1c3_udr": {
        this.emrservice.opto.udra1 = this.selectValue;
        break;
      }
      case "r1c4_udr": {
        this.emrservice.opto.udrp1 = this.selectValue;
        break;
      }
      case "r1c5_udr": {
        this.emrservice.opto.udrv1 = this.selectValue;
        break;
      }
      case "r1c6_udr": {
        this.emrservice.opto.udnvr1 = this.selectValue;
        break;
      }
      case "r1c7_udr": {
        this.emrservice.opto.udls1 = this.selectValue;
        break;
      }
      case "r1c8_udr": {
        this.emrservice.opto.udlc1 = this.selectValue;
        break;
      }
      case "r1c9_udr": {
        this.emrservice.opto.udla1 = this.selectValue;
        break;
      }
      case "r1c10_udr": {
        this.emrservice.opto.udlp1 = this.selectValue;
        break;
      }
      case "r1c11_udr": {
        this.emrservice.opto.udlv1 = this.selectValue;
        break;
      }
      case "r1c12_udr": {
        this.emrservice.opto.udnvl1 = this.selectValue;
        break;
      }

      // row 2

      case "r2c1_udr": {
        this.emrservice.opto.udrs2 = this.selectValue;
        break;
      }
      case "r2c2_udr": {
        this.emrservice.opto.udrc2 = this.selectValue;
        break;
      }
      case "r2c3_udr": {
        this.emrservice.opto.udra2 = this.selectValue;
        break;
      }
      case "r2c4_udr": {
        this.emrservice.opto.udrp2 = this.selectValue;
        break;
      }
      case "r2c5_udr": {
        this.emrservice.opto.udrv2 = this.selectValue;
        break;
      }
      case "r2c6_udr": {
        //this.emrservice.opto.udnvr = this.selectValue;
        break;
      }
      case "r2c7_udr": {
        this.emrservice.opto.udls2 = this.selectValue;
        break;
      }
      case "r2c8_udr": {
        this.emrservice.opto.udlc2 = this.selectValue;
        break;
      }
      case "r2c9_udr": {
        this.emrservice.opto.udla2 = this.selectValue;
        break;
      }
      case "r2c10_udr": {
        this.emrservice.opto.udlp2 = this.selectValue;
        break;
      }
      case "r2c11_udr": {
        this.emrservice.opto.udlv2 = this.selectValue;
        break;
      }
      case "r2c12_udr": {
        //  this.emrservice.opto.udnvl1 = this.selectValue;
        break;
      }

      // row 3


      case "r3c1_udr": {
        this.emrservice.opto.udrs3 = this.selectValue;
        break;
      }
      case "r3c2_udr": {
        this.emrservice.opto.udrc3 = this.selectValue;
        break;
      }
      case "r3c3_udr": {
        this.emrservice.opto.udra3 = this.selectValue;
        break;
      }
      case "r3c4_udr": {
        this.emrservice.opto.udrp3 = this.selectValue;
        break;
      }
      case "r3c5_udr": {
        this.emrservice.opto.udrv3 = this.selectValue;
        break;
      }
      case "r3c6_udr": {
        //this.emrservice.opto.udnvr = this.selectValue;
        break;
      }
      case "r3c7_udr": {
        this.emrservice.opto.udls3 = this.selectValue;
        break;
      }
      case "r3c8_udr": {
        this.emrservice.opto.udlc3 = this.selectValue;
        break;
      }
      case "r3c9_udr": {
        this.emrservice.opto.udla3 = this.selectValue;
        break;
      }
      case "r3c10_udr": {
        this.emrservice.opto.udlp3 = this.selectValue;
        break;
      }
      case "r3c11_udr": {
        this.emrservice.opto.udlv3 = this.selectValue;
        break;
      }
      case "r3c12_udr": {
        //  this.emrservice.opto.udnvl1 = this.selectValue;
        break;
      }

      // dilated row 1

      case "r1c1_dr": {
        this.emrservice.opto.drs1 = this.selectValue;
        break;
      }
      case "r1c2_dr": {
        this.emrservice.opto.drc1 = this.selectValue;
        break;
      }
      case "r1c3_dr": {
        this.emrservice.opto.dra1 = this.selectValue;
        break;
      }
      case "r1c4_dr": {
        //  this.emrservice.opto.drp1 = this.selectValue;
        break;
      }
      case "r1c5_dr": {
        this.emrservice.opto.drv1 = this.selectValue;
        break;
      }
      case "r1c6_dr": {
        // this.emrservice.opto.dnvr1 = this.selectValue;
        break;
      }
      case "r1c7_dr": {
        this.emrservice.opto.dls1 = this.selectValue;
        break;
      }
      case "r1c8_dr": {
        this.emrservice.opto.dlc1 = this.selectValue;
        break;
      }
      case "r1c9_dr": {
        this.emrservice.opto.dla1 = this.selectValue;
        break;
      }
      case "r1c10_dr": {
        //  this.emrservice.opto.dlp1 = this.selectValue;
        break;
      }
      case "r1c11_dr": {
        this.emrservice.opto.dlv1 = this.selectValue;
        break;
      }
      case "r1c12_dr": {
        this.emrservice.opto.dlremarks = this.selectValue;
        break;
      }


    }
  }
  // previous(){
  //   const currentIndex = this.dilatedStringArray.indexOf(this.inputtype);
  //   const newIndex = currentIndex === 0 ? this.dilatedStringArray.length - 1 : currentIndex - 1;
  //   let newvalue =this.dilatedStringArray[newIndex];
  //   if (isPlatformBrowser(this.platformId)) {
  //     this[newvalue].nativeElement.focus();
  //   }
  // }
  // next(){
  //   debugger
  //   const currentIndex = this.dilatedStringArray.indexOf(this.inputtype);
  //   const newIndex = currentIndex === this.dilatedStringArray.length - 1 ? 0  : currentIndex + 1;
  //   let newvalue =this.dilatedStringArray[newIndex];
  //   if (isPlatformBrowser(this.platformId)) {
  //     this[newvalue].nativeElement.focus();
  //   }
  // }
  refractionModal() {
    if (this.emrservice.unDilatedAndDilatedPermission?.isAddPermission == true) {
    document.getElementById("refractionModal").style.display = "block";
    this.inputtype = null;
    this.allowtablevalue = 0;
    this.emrservice.optohelplist = this.emrservice.opto;
    }else{
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  cancelRefractionModal() {
    document.getElementById("refractionModal").style.display = "none";
    this.emrservice.optohelplist = {};
    this.get_opto_data();
  }
  get_opto_data() {
   this.emrservice.get_opto_data().pipe(takeUntil(this.destroyud$)).subscribe(data => {
      this.emrservice.opto = data; 
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  focusFunction(type, value) {
    this.inputtype = type;
    this.allowtablevalue = value;

  }
  updateData() {
    this.emrservice.enabledisableUd = false;
    this.emrservice.opto = this.emrservice.optohelplist;
    document.getElementById("refractionModal").style.display = "none";
  }
  selectrowVlaue(row, type) {
    if (type == this.allowtablevalue) {

      switch (this.inputtype) {
        case "udrs1": {
          this.emrservice.optohelplist.udrs1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrc1'].nativeElement.focus();
          }
          break;
        }
        case "udrc1": {
          this.emrservice.optohelplist.udrc1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udra1'].nativeElement.focus();
          } 
          break;
        }
        case "udra1": {
          this.emrservice.optohelplist.udra1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrp1'].nativeElement.focus();
          }
          break;
        }
        case "udrp1": {
          this.emrservice.optohelplist.udrp1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrv1'].nativeElement.focus();
          }
          break;
        }
        case "udrv1": {
          this.emrservice.optohelplist.udrv1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udnvr1'].nativeElement.focus();
          }
          break;
        }
        case "udnvr1": {
          this.emrservice.optohelplist.udnvr1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrs2'].nativeElement.focus();
          }
          break;
        }
        case "udrs2": {
          this.emrservice.optohelplist.udrs2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrc2'].nativeElement.focus();
          }
          break;
        }
        case "udrc2": {
          this.emrservice.optohelplist.udrc2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udra2'].nativeElement.focus();
          }
          break;
        }
        case "udra2": {
          this.emrservice.optohelplist.udra2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrp2'].nativeElement.focus();
          }
          break;
        }
        case "udrp2": {
          this.emrservice.optohelplist.udrp2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrv2'].nativeElement.focus();
          }
          break;
        }
        case "udrv2": {
          this.emrservice.optohelplist.udrv2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrs3'].nativeElement.focus();
          }
          break;
        }
        case "udrs3": {
          this.emrservice.optohelplist.udrs3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrc3'].nativeElement.focus();
          }
          break;
        }
        case "udrc3": {
          this.emrservice.optohelplist.udrc3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udra3'].nativeElement.focus();
          }
          break;
        }
        case "udra3": {
          this.emrservice.optohelplist.udra3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrp3'].nativeElement.focus();
          }
          break;
        }
        case "udrp3": {
          this.emrservice.optohelplist.udrp3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrv3'].nativeElement.focus();
          }
          break;
        }
        case "udrv3": {
          this.emrservice.optohelplist.udrv3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udls1'].nativeElement.focus();
          }
          break;
        }
        case "udls1": {
          this.emrservice.optohelplist.udls1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlc1'].nativeElement.focus();
          }
          break;
        }
        case "udlc1": {
          this.emrservice.optohelplist.udlc1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udla1'].nativeElement.focus();
          }
          break;
        }
        case "udla1": {
          this.emrservice.optohelplist.udla1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlp1'].nativeElement.focus();
          }
          break;
        }
        case "udlp1": {
          this.emrservice.optohelplist.udlp1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlv1'].nativeElement.focus();
          }
          break;
        }
        case "udlv1": {
          this.emrservice.optohelplist.udlv1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udnvl1'].nativeElement.focus();
          }
          break;
        }
        case "udnvl1": {
          this.emrservice.optohelplist.udnvl1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udls2'].nativeElement.focus();
          }
          break;
        }
        case "udls2": {
          this.emrservice.optohelplist.udls2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlc2'].nativeElement.focus();
          }
          break;
        }
        case "udlc2": {
          this.emrservice.optohelplist.udlc2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udla2'].nativeElement.focus();
          }
          break;
        }
        case "udla2": {
          this.emrservice.optohelplist.udla2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlp2'].nativeElement.focus();
          }
          break;
        }
        case "udlp2": {
          this.emrservice.optohelplist.udlp2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlv2'].nativeElement.focus();
          }
          break;
        }
        case "udlv2": {
          this.emrservice.optohelplist.udlv2 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udls3'].nativeElement.focus();
          }
          break;
        }
        case "udls3": {
          this.emrservice.optohelplist.udls3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlc3'].nativeElement.focus();
          }
          break;
        }
        case "udlc3": {
          this.emrservice.optohelplist.udlc3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udla3'].nativeElement.focus();
          }
          break;
        }
        case "udla3": {
          this.emrservice.optohelplist.udla3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlp3'].nativeElement.focus();
          }
          break;
        }
        case "udlp3": {
          this.emrservice.optohelplist.udlp3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udlv3'].nativeElement.focus();
          }
          break;
        }
        case "udlv3": {
          this.emrservice.optohelplist.udlv3 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['drs1'].nativeElement.focus();
          }
          break;
        }
        case "drs1": {
          this.emrservice.optohelplist.drs1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['drc1'].nativeElement.focus();
          }
          break;
        }
        case "drc1": {
          this.emrservice.optohelplist.drc1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dra1'].nativeElement.focus();
          }
          break;
        }
        case "dra1": {
          this.emrservice.optohelplist.dra1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['drv1'].nativeElement.focus();
          }
          break;
        }
        case "drv1": {
          this.emrservice.optohelplist.drv1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dls1'].nativeElement.focus();
          }
          break;
        }
        case "dls1": {
          this.emrservice.optohelplist.dls1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dlc1'].nativeElement.focus();
          }
          break;
        }
        case "dlc1": {
          this.emrservice.optohelplist.dlc1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dla1'].nativeElement.focus();
          }
          break;
        }
        case "dla1": {
          this.emrservice.optohelplist.dla1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dlv1'].nativeElement.focus();
          }
          break;
        }
        case "dlv1": {
          this.emrservice.optohelplist.dlv1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['udrs1'].nativeElement.focus();
          }
          break;
        }
      }
    } else {
      this.dashboardService.openSnackBar("Select Correct Value", "OK");
    }
  }
}
